<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import AgentActivityList from './AgentActivityList.vue';
import AgentRunList from './AgentRunList.vue';
import AgentSection from './AgentSection.vue';

defineProps({
  runs: { type: Array, default: () => [] },
  canManage: { type: Boolean, default: false },
  selectedRunDetail: { type: Object, default: null },
  loadingRunId: { type: [Number, String], default: null },
  hasMoreRuns: { type: Boolean, default: false },
  isLoadingMoreRuns: { type: Boolean, default: false },
  recentActivityItems: { type: Array, default: () => [] },
});

const emit = defineEmits(['cancelRun', 'toggleRunDetails', 'loadMoreRuns']);
const { t: ce } = useI18n();
</script>

<template>
  <section id="agent-performance" class="flex flex-col gap-8" tabindex="-1">
    <AgentSection
      :title="ce('CAPTAIN_EXPERIENCE.AUTO.HISTORICO_DE_ATENDIMENTOS')"
    >
      <AgentRunList
        :runs="runs"
        :can-cancel="canManage"
        :can-view-details="canManage"
        :selected-run="selectedRunDetail"
        :loading-run-id="loadingRunId"
        :cancel-label="ce('CAPTAIN_EXPERIENCE.SCRIPT.CANCEL_RUN')"
        :details-label="ce('CAPTAIN_EXPERIENCE.SCRIPT.RUN_DETAILS')"
        :close-details-label="ce('CAPTAIN_EXPERIENCE.SCRIPT.CLOSE_RUN_DETAILS')"
        :messages-label="ce('CAPTAIN_EXPERIENCE.SCRIPT.RUN_MESSAGES')"
        :actions-label="ce('CAPTAIN_EXPERIENCE.SCRIPT.RUN_ACTIONS')"
        :approvals-label="ce('CAPTAIN_EXPERIENCE.SCRIPT.RUN_APPROVALS')"
        :empty-label="
          ce('CAPTAIN_EXPERIENCE.AUTO.NENHUM_ATENDIMENTO_REGISTRADO_AINDA')
        "
        :missing-response-label="
          ce('CAPTAIN_EXPERIENCE.AUTO.RESPOSTA_AINDA_NAO_REGISTRADA')
        "
        @cancel="emit('cancelRun', $event)"
        @view="emit('toggleRunDetails', $event)"
      />
      <Button
        v-if="hasMoreRuns"
        class="mt-3"
        type="button"
        color="slate"
        variant="faded"
        :is-loading="isLoadingMoreRuns"
        :label="ce('CAPTAIN_EXPERIENCE.SCRIPT.LOAD_MORE')"
        @click="emit('loadMoreRuns')"
      />
    </AgentSection>
    <AgentActivityList
      :items="recentActivityItems"
      :title="ce('CAPTAIN_EXPERIENCE.AUTO.ATIVIDADE_RECENTE')"
      :empty-label="
        ce('CAPTAIN_EXPERIENCE.AUTO.NENHUMA_ATIVIDADE_REGISTRADA_AINDA')
      "
    />
  </section>
</template>
